<template>
  <b-container class="py-5">
    <b-row>
      <b-col v-show="products.total > 0">
        <DeckProducts :carousel="false" :products="products.docs" :quantity="3" :productProps="productProps"/>
      </b-col>
      <b-col v-show="products.total < 1">
        <h2 class="text-center">No hay productos en esta categoria</h2>
      </b-col>
    </b-row>
    <b-overlay :show="overlay" rounded="sm" fixed no-wrap />
  </b-container>
</template>

<script>
import DeckProducts from '@/components/DeckProducts'

export default {
  name: 'Category',
  components: { DeckProducts },
  computed: {
    readonlyRating () {
      return !this.$store.user
    },
    category () {
      return this.$route.params.slug
    }
  },
  async mounted () {
    await this.fetchProducts()
  },
  watch: {
    async category (value) {
      await this.fetchProducts()
    }
  },
  data () {
    return {
      overlay: true,
      products: {
        docs: [],
        total: 0
      },
      productProps: {
        subtitleVariant: 'primary'
      }
    }
  },
  methods: {
    async fetchProducts () {
      this.overlay = true
      const response = await this.$http.get(`/products?category=${this.$route.params.slug}`)
      this.products = response.data
      this.overlay = false
    }
  }
}
</script>
